import React from 'react';
import BaseFilter from './base_filter';
import { FILTER_OPTIONS} from "./filter_constants_and_helpers";
import FilterSelect from '../partners/filter_select'

class GenderFilter extends BaseFilter {

    constructor(props) {
        super(props)

        Object.assign(this.state,this.stored || this._defaultValue())
        this._setDefault = this._setDefault.bind(this)

        // get visible options from all options.
        this.options = FILTER_OPTIONS.genders

        this._setFiltersInternal = this._setFiltersInternal.bind(this)
        this.removeFilter = this.removeFilter.bind(this)
    }

    removeFilter(name) {
        if ( name ) {
            this._setFiltersInternal(GenderFilter.getFilterName(), this._dropDownRemoveFilter(name, " gender"))
        } else {
            this._setDefault()
        }
    }

    /**
     * The following set of function starting with _ are 'protected' and should be called by the base class only.
     * @private
     */
    _defaultValue() {
        return {in:[]}
    }

    _setDefault() {
        this.setFilters(GenderFilter.getFilterName(),this._defaultValue())
    }

    _setFiltersInternal(filterName,newValue) {
        this.setFilters(filterName,{in:newValue},this.removeFilter)
    }

    _render() {
        return <div><FilterSelect
            label={"Gender"}
            name={GenderFilter.getFilterName()}
            options={this.options}
            route={"recent_deals_"+this.props.itemType}
            selectedOptions={this.state.in}
            setFilters={this._setFiltersInternal}
            systemName={GenderFilter.getFilterName()}
        />
        </div>
    }

    _getFilterValue() {
        return {in:this.state.in}
    }

    _getFilterName() {
        return GenderFilter.getFilterName()
    }

    _tagName(newState) {
        let tagList = []
        for ( let id of newState.in ) {
            tagList.push(this.options.find(e => e.id == id).pretty_name + ' gender')
        }
        return tagList
    }

    _apiKeys() {
        return ["in"]
    }

    /**
     * static functions to be supported without an instance for generic filter usage implementations.
     * @returns {string}
     */
    static getFilterName() {
        return "gender"
    }
}

export default GenderFilter;